import { gql } from 'apollo-boost'

const RESOLVE_BRAND_DEFINITION_TASK = gql`
  mutation resolveBrandDefinitionTask(
    $id: ID!
    $brandData: SaveBrandDefinitionTaskBrandInput
  ) {
    resolveBrandDefinitionTask(id: $id, brandData: $brandData) {
      brandDefinitionTask {
        id
      }
      menuDefinitionTask {
        id
      }
    }
  }
`

export default RESOLVE_BRAND_DEFINITION_TASK
